import {PatientTherapySequenceStatus} from '@cypro/engine/database/schema'

export const patientTherapySequenceStatusOptions = Object.values(PatientTherapySequenceStatus.enum)

/**
 * Status options offered in the filters. QA & dispatch is skipped when the unit is released
 * automatically (`deliveryAutoRelease`), so that step is not used; a prescription already in a
 * hidden status still shows its status.
 */
export function getTherapySequenceStatusOptions(settings: {deliveryAutoRelease?: boolean | null} | undefined) {
  return patientTherapySequenceStatusOptions.filter(
    status => !(status === PatientTherapySequenceStatus.enum.qa_dispatch && settings?.deliveryAutoRelease)
  )
}
